<div class="question-library">
  @if (!backlogOfQuestions$()) {
    <div class="question-library__loading">
      <div class="question-library__loading-content">
        <mat-spinner diameter="40"></mat-spinner>
        <span class="fs__lg">Loading library</span>
      </div>
    </div>
  } @else {
    @if (backlogOfQuestions$().length > 0) {
      <div class="question-library__container">
        <div class="question-library__header">
          <h1 class="fs__xl">Questions Library</h1>
          <span class="question-library__header-description fs__md">Pick from the stored questions</span>

          <div class="question-library__filters">
            <span class="question-library__filters-checked fs__md fw__500">{{ selectedQuestionIndex$().length }} selected</span>
            <eiq-search-input placeholder="Type to filter by question title" [(ngModel)]="filterCtrl"></eiq-search-input>
            <eiq-select
              placeholder="Filter by type"
              defaultOption="All"
              [showDefaultOption]="true"
              [(ngModel)]="typeCtrl"
              [options]="questionTypesToFilter$()"
            ></eiq-select>
          </div>
        </div>

        <div class="question-library__grid">
          @for (question of questionsOnLibrary$(); track question.id) {
            <empathy-question-library-item
              [question]="question"
              [isChecked]="selectedQuestionIndex$().includes($index)"
              (checked)="onChecked($event, $index)"
              (deleteQuestion)="onDeleteQuestionFromLibrary($event)"
            ></empathy-question-library-item>
          }
        </div>
      </div>
    } @else {
      <div class="question-library__empty">
        <div class="question-library__empty-title">
          <fa-icon [icon]="faFolderBookmark"></fa-icon>
          <h2 class="fs__md fw__500">There are no questions stored on the library</h2>
        </div>
      </div>
    }
  }
</div>
